module.exports = __webpack_public_path__ + "img/湾区认证证书.f9c87f7d.png";